import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { BrandService } from '../../_ecomservices/brand.service';
import { MatDialogRef, MatTableDataSource } from '@angular/material';
import { ProductCreateComponent } from '../product-create/product-create.component';

@Component({
  selector: 'app-brand-create',
  templateUrl: './brand-create.component.html',
  styleUrls: ['./brand-create.component.css']
})
export class BrandCreateComponent implements OnInit {

  brand_img: File = null;
  brandImagePreview: string | ArrayBuffer | null = null;

  brandList:any = [];
  dataSource: MatTableDataSource<any>;
  
  constructor(private dialogRef: MatDialogRef<ProductCreateComponent>,
    private titleService: Title,
    public brandService: BrandService,
    private loading : LoadingService,
    private notificationService: NotificationService,) { }

  onSelectBrandImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.brand_img = file;
      // this.categoryService.category_form.patchValue({ cat_img: file });      
      //this.categoryService.category_form.get('cat_img')!.updateValueAndValidity();
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.brandImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Brand Create');
    this.onLoadBrands();
  }

  onLoadBrands() {
    var result = this.brandService.get_brands().subscribe(data=> {
      this.brandList = data['brandList'];
      this.dataSource = new MatTableDataSource<any>(data['brandList']);
      this.loading.spin$.next(false);
    });
  }

  onBrandFormSubmit(formData: any)
  {
    if(this.brandService.brand_form.valid)
    {
      this.loading.spin$.next(true);
      this.brandService.insert_brand(formData, this.brand_img).subscribe(data=>{
        console.log(data);
        if (data['status']) 
        {
          this.notificationService.success(data['message']); 
          //this.categoryService.category_form.reset();
          this.onClose(data);
          this.loading.spin$.next(false);
        } 
        else
        {
          this.notificationService.error(data['error_message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

  onClose(data)
  {
    this.brandService.brand_form.reset();
    this.dialogRef.close(data);  
  }

  onFileChange(event){

  }

}
